export default "__VITE_ASSET__DD0G0SJf__"